var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components'; //import defaultLogo from '../static/fiducius-logo-2.png';

import whiteLogo from '../static/fiducius-logo-lg-white.png';
import regularLogo from '../static/fiducius-logo-2.png';
var Nav = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  background: linear-gradient(0deg, ", " 0%, ", " 100%);\n  border-right: ", " solid ", ";\n  bottom: 0;\n  box-shadow: ", ";\n  list-style: none;\n  overflow-y: auto;\n  padding-bottom: 2.5em;\n  position: fixed;\n  top: inherit;\n  width: inherit;\n"], ["\n  background-color: ", ";\n  background: linear-gradient(0deg, ", " 0%, ", " 100%);\n  border-right: ", " solid ", ";\n  bottom: 0;\n  box-shadow: ", ";\n  list-style: none;\n  overflow-y: auto;\n  padding-bottom: 2.5em;\n  position: fixed;\n  top: inherit;\n  width: inherit;\n"])), function (p) {
  return p.theme.level1;
}, function (p) {
  return p.theme.level1B;
}, function (p) {
  return p.theme.level1;
}, function (p) {
  return p.theme.borderWidth;
}, function (p) {
  return p.theme.level3;
}, function (p) {
  return p.theme.boxShadow;
});
var Logo = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-self: center;\n  height: auto;\n  max-height: calc(", " - 0.5rem);\n  max-width: 100%;\n"], ["\n  align-self: center;\n  height: auto;\n  max-height: calc(", " - 0.5rem);\n  max-width: 100%;\n"])), function (p) {
  return p.theme.topBarHeight;
});
var StyledLogoDisplay = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: auto;\n  max-height: calc(", " - 0.5rem);\n  max-width: 100%;\n"], ["\n  height: auto;\n  max-height: calc(", " - 0.5rem);\n  max-width: 100%;\n"])), function (p) {
  return p.theme.topBarHeight;
});
var LogoWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  ", ";\n  padding: 0.25rem 1rem;\n\n  @media (max-width: 576px) {\n    display: none;\n    visibility: hidden;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  ", ";\n  padding: 0.25rem 1rem;\n\n  @media (max-width: 576px) {\n    display: none;\n    visibility: hidden;\n  }\n"])), function (p) {
  return p.theme.sidebarWidthAdjust('width', p);
});

var getLogo = function getLogo(p, defaultLogo) {
  if (defaultLogo !== whiteLogo) {
    return defaultLogo;
  } else {
    return p !== 'light' && p !== 'newlight' ? whiteLogo : regularLogo;
  }
};

var NavSide = function NavSide(_a) {
  var children = _a.children,
      theme = _a.theme,
      _b = _a.logo,
      logo = _b === void 0 ? whiteLogo : _b;
  return React.createElement(Nav, {
    className: "nav-side"
  }, React.createElement(LogoWrapper, {
    className: "navbar-logo"
  }, React.createElement(Logo, {
    src: getLogo(theme, logo),
    alt: "Fiducius Logo"
  })), children);
};

var LogoDisplay = function LogoDisplay(_a) {
  var _b = _a.logo,
      logo = _b === void 0 ? whiteLogo : _b,
      _c = _a.wrapper,
      wrapper = _c === void 0 ? false : _c;

  if (wrapper) {
    return React.createElement(LogoWrapper, {
      className: "navbar-logo"
    }, React.createElement(StyledLogoDisplay, {
      src: logo,
      alt: "Fiducius Logo"
    }));
  } else {
    return React.createElement(StyledLogoDisplay, {
      src: logo,
      alt: "Fiducius Logo"
    });
  }
};

export { NavSide, LogoDisplay };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;